import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_oselya_dark.svg";
import lightModeLogo from "./logos/logo_oselya_light.svg";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "USD";

export const defaultTitle = "Oselya";

export const defaultCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

export const defaultDealStages = [
  { value: "new", label: "Новий", color: "#5f84a6" },
  { value: "in-progress", label: "В роботі", color: "#2d8a52" },
  { value: "viewing", label: "Показ", color: "#7a6aa8" },
  { value: "booking", label: "Бронь", color: "#d89a2b" },
  { value: "contract", label: "Договір", color: "#2f5d46" },
  // "won" and "lost" are referenced by code: keep these values
  { value: "won", label: "Продано", color: "#1f7a7a" },
  { value: "lost", label: "Втрачено", color: "#a82f23" },
];

export const defaultDealPipelineStatuses = ["won"];

// docs/design/Settings.dc.html "Причини втрати": keep it short, analytics count them
export const defaultDealLostReasons = [
  { value: "expensive", label: "Дорого" },
  { value: "not-now", label: "Не на зараз" },
  { value: "no-answer", label: "Не додзвонились" },
  { value: "not-target", label: "Не ціль" },
  { value: "competitor", label: "Обрали конкурента" },
  { value: "other", label: "Інше" },
];

export const defaultDealCategories = [
  { value: "apartment", label: "Квартира" },
  { value: "commercial", label: "Комерційне приміщення" },
  { value: "parking", label: "Паркінг" },
  { value: "other", label: "Інше" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Холодний", color: "#7dbde8" },
  { value: "warm", label: "Теплий", color: "#e8cb7d" },
  { value: "hot", label: "Гарячий", color: "#e88b7d" },
  { value: "in-contract", label: "Договір", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "call", label: "Дзвінок" },
  { value: "callback", label: "Передзвонити" },
  { value: "viewing", label: "Показ квартири" },
  { value: "meeting", label: "Зустріч" },
  { value: "send-docs", label: "Надіслати документи" },
  { value: "none", label: "Інше" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  dealLostReasons: defaultDealLostReasons,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
